import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { 
    window.onscroll = ()=> { 
      this.scrollFunction()
    };
  }

  ngOnInit() {
  }

  scrollFunction() {
    // let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    // let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    // let scrolled = (winScroll / height) * 100;
    // document.getElementById("main-content").style.top = (100 - scrolled) + "%";
    if(window.scrollY !=0){
      let ele = document.getElementById("topBar");
      ele.style.position = 'fixed';
      ele.style.background = '#1c9f99';
      ele.style.zIndex = '600';
    }
    else{
      let ele = document.getElementById("topBar");
      ele.style.position = 'static';
      ele.style.background = 'transparent';
      ele.style.zIndex = '600';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts